import { testimonialsData } from '@/mocks/home';
import EditableImage from '@/components/base/EditableImage';

export default function TestimonialSection() {
  return (
    <section id="depoimentos" className="py-20 md:py-28 bg-cream overflow-hidden">
      <div className="px-6 md:px-10 lg:px-16">
        <div className="text-center mb-16 md:mb-20">
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-dark font-normal leading-tight tracking-wide">
            Depoimentos <span className="text-warm-700 text-3xl md:text-4xl align-middle ml-1">♥</span>
          </h2>
          <div className="mt-4 mx-auto w-16 h-px bg-warm-600/40"></div>
        </div>

        <div className="max-w-6xl mx-auto space-y-8 md:space-y-10">
          {testimonialsData.map((item) => (
            <div
              key={item.id}
              className="bg-dark rounded-3xl overflow-hidden shadow-xl"
            >
              <div className="flex flex-col md:flex-row">
                <div className="w-full md:w-2/5 relative">
                  <div className="h-64 md:h-full md:absolute md:-left-8 lg:-left-10 md:top-1/2 md:-translate-y-1/2">
                    <div className="w-full h-full md:w-64 lg:w-72 md:h-[110%] rounded-2xl overflow-hidden shadow-2xl">
                      <EditableImage
                        imageKey={`testimonial-${item.id}`}
                        src={item.image}
                        alt={item.author}
                        containerClassName="w-full h-full"
                        className="w-full h-full object-cover"
                      />
                    </div>
                  </div>
                </div>

                <div className="w-full md:w-3/5 p-8 md:p-10 lg:p-12 md:pl-16 lg:pl-20">
                  <div className="text-warm-400 text-4xl md:text-5xl font-serif leading-none mb-4">
                    &ldquo;
                  </div>
                  <blockquote className="text-white/90 text-sm md:text-base lg:text-lg leading-relaxed font-light mb-6 whitespace-pre-line">
                    {item.quote}
                  </blockquote>
                  <div className="mt-auto">
                    <p className="text-white font-medium text-sm md:text-base">
                      {item.author}
                    </p>
                    <div className="mt-2 flex items-center gap-1">
                      <i className="ri-star-fill text-warm-400 text-xs" />
                      <i className="ri-star-fill text-warm-400 text-xs" />
                      <i className="ri-star-fill text-warm-400 text-xs" />
                      <i className="ri-star-fill text-warm-400 text-xs" />
                      <i className="ri-star-fill text-warm-400 text-xs" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}